import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import AppBar from "@mui/material/AppBar";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { Typography, Dialog, DialogTitle, DialogContent } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Slide from "@mui/material/Slide";
import { useStyles } from "../../assets/styles/Theme";
import AddToolbar from "../../components/common/AddToolbar";
import Navbar from "../../components/common/Navbar";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import Popover from "@mui/material/Popover";

import { useSelector } from "react-redux";

function Schedules() {
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const location = useLocation();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const SYS_USER = useSelector((state) => state.user) || {};

  const [errors, setErrors] = useState({});
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    MENUCATNAME: "",
    MENUCATCODE: "",
    MENUTYPECODE: "",
  });
  const isEdit = location.state?.actionText === "Edit";

  const [error, setError] = useState({
    MENUCATNAME: "",
    MENUTYPECODE: "",
  });

  const [selectedDate, setSelectedDate] = useState(null);
  const [open, setOpen] = useState(false);
  const [meetingDetails, setMeetingDetails] = useState("");

  // Function to handle date changes specifically

  const gotToView = () => {
    navigate("/VSchedule");
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  const handleConfirmClick = () => {
    //add confirm button click event
    alert("add confirm button click event");
  };

  const handleClearClick = () => {
    //add Clear button click event
    alert("add Clear button click event");
  };

  // sample Sheduled meetings for meetings calender
  const meetings = {
    "2024-11-29": "Team meeting at 08:00 AM",
    "2024-11-30": "Annual meeting at 09:00 AM",
    "2024-12-01": "Project deadline discussion at 10:00 AM",
    "2024-12-02": "Team meeting at 11:00 AM",
    "2024-12-05": "Project deadline discussion at 2:00 PM",
  };

  const handleDayClick = (date) => {
    //calendar selected date click event
    date = dayjs(date).format("YYYY-MM-DD");
    const formattedDate = dayjs(date).format("YYYY-MM-DD"); // Format as YYYY-MM-DD
    setSelectedDate(formattedDate);
    setMeetingDetails(meetings[formattedDate] || "No meetings scheduled");
    setOpen(true);
  };

  const handleClose = () => {
    //add close function to opende popup
    setOpen(false);
  };
  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none" href="/">
                  Home
                </Link>
                <Link underline="none">Schedules</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.box_container}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={styles.col_title}>
              <Typography variant="title" align="left">
                Schedules
              </Typography>
            </Box>
          </Grid>
          {/* Form Section */}
          <Grid item xs={12} sm={12} md={5}>
            <Box
              p={2}
              sx={{
                ...styles.col_1,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "flex-start",
                textAlign: "left",
                padding: 2,
                marginLeft: 0,
                height: "70vh",
                borderRadius: "4px",
                boxShadow: `0px 0px 4px 0px ${theme.palette.input_field.stroke}`,
                background: theme.palette.background.default,

                borderRight: theme.palette.divider,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Typography
                    sx={{
                      ...theme.typography.h2,
                      color: theme.palette.text.primary,
                      p: 2,
                    }}
                  >
                    Add Schedules
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Date"
                      value={
                        selectedItemDetails.EXPIRYDATE
                          ? dayjs(selectedItemDetails.EXPIRYDATE)
                          : null
                      }
                      slotProps={{
                        textField: {
                          error: Boolean(errors.EXPIRYDATE), // Pass error here
                          helperText: errors.EXPIRYDATE, // Pass helperText here
                          sx: {
                            width: "100%",
                            "& .MuiInputBase-root": {
                              height: "40px",
                              marginTop: "0.3rem",
                            },
                            "& .MuiInputAdornment-root .MuiIconButton-root": {
                              color: theme.palette.primary.main, // Change icon color here
                            },
                          },
                        },
                        popper: {
                          sx: {
                            "& .MuiPaper-root": {
                              backgroundColor: theme.palette.background.paper, // Background color of the popper
                              boxShadow: "none", // Remove box shadow if needed
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label={
                      <span>
                        Guest Name<span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    size="small"
                    fullWidth
                    variant="outlined"
                    // autoComplete="off"

                    name="MENUCATNAME"
                    // value={}
                    error={Boolean(errors.MENUCATNAME)}
                    helperText={errors.MENUCATNAME}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label={
                      <span>
                        Contact Number<span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    size="small"
                    fullWidth
                    variant="outlined"
                    autoComplete="off"
                    name="MENUCATNAME"
                    // value={}
                    error={Boolean(errors.MENUCATNAME)}
                    helperText={errors.MENUCATNAME}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label={
                      <span>
                        Email<span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    size="small"
                    fullWidth
                    variant="outlined"
                    autoComplete="off"
                    name="MENUCATNAME"
                    // value={}
                    error={Boolean(errors.MENUCATNAME)}
                    helperText={errors.MENUCATNAME}
                  />
                </Grid>
                <Grid item xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["TimePicker", "TimePicker"]}>
                      <Grid container>
                        <Grid item sm={6}>
                          <TimePicker
                            name="Start Time"
                            label="Start Time"
                            size="small"
                            fullWidth
                            variant="outlined"
                            autoComplete="off"
                            // InputLabelProps={{
                            //   sx: { fontSize: "0.2rem",},
                            // }}
                            slotProps={{
                              textField: {
                                error: Boolean(errors.EXPIRYDATE), // Pass error here
                                helperText: errors.EXPIRYDATE, // Pass helperText here
                                sx: {
                                  overflow: "hidden",
                                  width: "100%",
                                  "& .MuiInputBase-root": {
                                    height: "40px",
                                    marginTop: "0.4rem",
                                    marginRight: "1rem",
                                  },
                                  "& .MuiInputAdornment-root .MuiIconButton-root":
                                    {
                                      color: theme.palette.primary.main, // Change icon color here
                                    },
                                },
                              },
                              popper: {
                                sx: {
                                  "& .MuiPaper-root": {
                                    backgroundColor:
                                      theme.palette.background.paper, // Background color of the popper
                                    boxShadow: "none", // Remove box shadow if needed
                                    padding: 0,
                                  },
                                },
                              },
                            }}
                          />
                        </Grid>
                        <Grid item sm={6}>
                          <TimePicker
                            name="End Time"
                            label="End Time"
                            size="small"
                            fullWidth
                            variant="outlined"
                            autoComplete="off"
                            InputLabelProps={{
                              marginTop: "0.3rem",
                            }}
                            slotProps={{
                              textField: {
                                error: Boolean(errors.EXPIRYDATE), // Pass error here
                                helperText: errors.EXPIRYDATE, // Pass helperText here
                                sx: {
                                  overflow: "hidden",
                                  width: "100%",
                                  "& .MuiInputBase-root": {
                                    height: "40px",
                                    //  marginTop: "0.3rem",
                                  },
                                  "& .MuiInputAdornment-root .MuiIconButton-root":
                                    {
                                      color: theme.palette.primary.main, // Change icon color here
                                    },
                                },
                              },
                              popper: {
                                sx: {
                                  "& .MuiPaper-root": {
                                    backgroundColor:
                                      theme.palette.background.paper, // Background color of the popper
                                    boxShadow: "none", // Remove box shadow if needed
                                  },
                                },
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </DemoContainer>
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    name="REMARK"
                    label="Remark"
                    size="small"
                    fullWidth
                    variant="outlined"
                    autoComplete="off"

                    // value={}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Button
                    variant="outlined"
                    sx={styles.btn_secondary}
                    onClick={handleClearClick}
                  >
                    Clear
                  </Button>
                </Grid>

                <Grid item xs={6}>
                  <Button
                    variant="contained"
                    sx={styles.btn_primary}
                    onClick={handleConfirmClick}
                  >
                    {isEdit ? "Modify" : "Confirm"}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12} md={7} pr={1}>
            <Box
              sx={{
                ...styles.col_1,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "flex-start",
                textAlign: "left",
                padding: 2,
                marginLeft: 0,
                height: "70vh", // Container height
                borderRadius: "4px",
                boxShadow: `0px 0px 4px 0px ${theme.palette.input_field.stroke}`,
                background: theme.palette.background.default,
                borderRight: theme.palette.divider,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      ...theme.typography.h2,
                      color: theme.palette.text.primary,
                      p: 2,
                    }}
                  >
                    Schedule Calendar
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Box
                      sx={{
                        height: "100%", // Occupy all available space
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <DateCalendar
                        defaultValue={dayjs("2022-04-17")}
                        onChange={handleDayClick}
                        sx={{
                          height: "100%",
                          backgroundColor: "#f5f5f5",
                          border: "2px ", // Add a border
                          borderRadius: "4px",
                          boxShadow: "0px 0px 4px 0px #BAD6F2",
                          "& .MuiCalendarPicker-root": {
                            height: "100%",
                            maxWidth: "unset", // Remove width limits
                            padding: 4,
                            justifyContent: "space-between", // Spread out elements
                          },
                          "& .MuiCalendarPicker-root": {
                            height: "100%",
                            maxWidth: "unset", // Remove width limits
                            padding: 2,
                            justifyContent: "space-between", // Spread out elements
                          },
                          "& .MuiTypography-root": {
                            fontSize: "1.5rem", // Header font size
                            margin: "3px",
                          },
                          "& .MuiPickersDay-root": {
                            fontSize: "1.2rem",
                            margin: "3px",
                            color: "#5C5C5C",
                          },
                          "& .MuiPickersDay-root.Mui-selected": {
                            backgroundColor: theme.palette.primary.main, // Primary color for selected
                            color: theme.palette.primary.contrastText, // Set contrast color for selected date
                            borderRadius: "50%",
                            cursor: "pointer",
                          },
                        }}
                      />

                      <Dialog open={open} onClose={handleClose}>
                        {/* Primary color for selected */}
                        <DialogTitle>Meeting Details</DialogTitle>{" "}
                        <DialogContent>
                          <Typography>
                            {selectedDate}: {meetingDetails}
                          </Typography>
                        </DialogContent>
                      </Dialog>
                    </Box>
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          // Slide in from the right
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          autoHideDuration={6000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
}

export default Schedules;
